/** Ordered steps of the screener flow. Used for routing + progress tracking. */
export const STEPS = [
    "welcome",
    "headphones",
    "set-volume",
    "test",
    "questions",
    "details",
    "results",
];
export const PLATFORMS = [
    "clear-earwax",
    "earwax-org-uk",
    "hearing-expert",
];
